export default (name: string) => {
    const parsedName = name.split(' ')
    return { collection: parsedName.slice(0, -1).join(' '), index: parsedName[parsedName.length - 1] }
}